// ------------------------------------
// Slide
// ------------------------------------

const slideCarroselClass = '.slide-lista';

slideInitSlick();

// Desabilita o plugin de carrosel
function slideDestroySlick() {
  const $slideCarrosel = $(slideCarroselClass);
  $slideCarrosel.each(function () {
    const $slideItem = $(this);
    if ($slideItem.hasClass('slick-slider')) {
      $slideItem.slick('unslick');
    }
  });
}

// Aplica o plugin de carrosel
function slideInitSlick() {
  const $slideCarrosel = $(slideCarroselClass);
  $slideCarrosel.each(function () {
    const $slideItem = $(this);
    if (!$slideItem.hasClass('slick-initialized')) {
      let speed = $slideItem.data('speed') * 1000;
      let dots = $slideItem.children().length > 1;
      let slideAutoplay = $slideItem.data('autoplay') == 1;
      let slideAutoplayMobile = $slideItem.data('autoplay-mobile') == 1;
      $slideItem.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: dots,
        infinite: true,
        autoplay: slideAutoplay,
        autoplaySpeed: speed,
        adaptiveHeight: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        //lazyLoad: 'ondemand',

        // Responsivo
        responsive: [
          // Mobile
          {
            breakpoint: 768,
            settings: {
              autoplay: slideAutoplayMobile,
              arrows: false,
            },
          },
        ],
      });
    }
  });
}

if ($(slideCarroselClass).length > 0) {
  doWhenVisible($(slideCarroselClass), function () {
    const $slideCarrosel = $(slideCarroselClass);
    $slideCarrosel.each(function () {
      const $slideItem = $(this);
      if ($slideItem.hasClass('slick-slider')) {
        $slideItem.slick('resize');
      }
    });
  });
}

if (!previewMode) {
  slickReinitLazy($(slideCarroselClass), slideInitSlick, slideDestroySlick);
}
